import React, { useEffect, useState } from 'react'
import UserResponsiveTable from '../../components/form/users/UsersResponsiveTable'
const Users = () => {

  return (
   <UserResponsiveTable/>
  )
}

export default Users